(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ipmConstants'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('download-haq-results-reports', {
            parent: 'app',
            url: '/download-haq-results-reports',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_BILLER'],
                pageTitle: 'ipmApp.downloadHAQResultsReports.home.pageTitle'
            },
            views: {
                'content@': {
                    templateUrl: 'app/download-haq-results-reports/download-haq-results-reports.html',
                    controller: 'DownloadHAQResultsReportsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('downloadHAQResultsReports');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                isAdhoc: function () {
                    return false;
                }
            },
        }).state('download-adhoc-tests-reports', {
            parent: 'app',
            url: '/download-adhoc-tests-reports',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_BILLER'],
                pageTitle: 'ipmApp.downloadAdhocTestsReports.home.pageTitle'
            },
            views: {
                'content@': {
                    templateUrl: 'app/download-haq-results-reports/download-haq-results-reports.html',
                    controller: 'DownloadHAQResultsReportsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('downloadHAQResultsReports');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                isAdhoc: function () {
                    return true;
                }
            }
        }).state('download-haq-results-reports.requested', {
            parent: 'download-haq-results-reports',
            url: '/requested/{secretKey}',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_BILLER'],
                pageTitle: 'global.menu.entities.downloadActivityReport'
            },
            views: {
                'content@': {
                    templateUrl: 'app/download-haq-results-reports/request-haq-results-reports.html',
                    controller: 'RequestHAQResultsReportsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('downloadHAQResultsReports');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
